import React, { Component } from "react";
//import { Link } from 'react-router-dom';

import "./styles/MarketStore.css";

import StoreLeft from "../components/StoreLeft";
import MarketStoreSlider from "../components/MarketStoreSlider";
import StoreCenter from "../components/StoreCenter";
import { StoreSkeleton } from "../components/Skeleton";
import { I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import * as actions_store from "../redux/actions/marketstoreActions";
//import * as actions_ad_store from "../redux/actions/marketstoreAdListActions";
import alertify from "alertifyjs";
import "../components/styles/Alertify.css";
import "../components/styles/AlertifyTheme.css";
import "../components/styles/Alertify.min.css";
import "../components/styles/AlertifyTheme.min.css";

class MarketStore extends Component {

  state = { marketstoreId: "" };

  async componentDidMount() {
    // await this.setState({ marketstoreId: this.props.match.params.store_id });
    this.fetchMarketStore(this.props.match.params.store_id);
  }

  isLoggedIn = () =>
    Boolean(
      this.props.user_id &&
      this.props.token &&
      JSON.stringify(this.props.auth) !== "{}"
    );

  fetchMarketStore = async (marketstoreId) => {
    if (!marketstoreId) return;
    try {
      if (this.isLoggedIn()) {
        await this.props.LoadMarketStore(this.props.token, {
          id: this.props.user_id,
          store_id: marketstoreId,
          lang: I18n.t("locale"),
        });
      } else {
        await this.props.LoadMarketStoreOut({
          store_id: marketstoreId,
          lang: I18n.t("locale"),
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.loading && !this.props.loading && this.props.error) {
      alertify.warning(I18n.t(this.props.error));
    }
  }

  componentWillUnmount() {
    this.props.ClearMarketstore();
  }

  render() {
    if (this.props.loading)
      return (
        <div className="container-fluid marketstore-page">
          <div className="marketstore-body">
            <StoreSkeleton />
          </div>
        </div>
      );
    if (this.props.error || !this.props.marketstore?.Id) {
      return (
        <div className="container-fluid marketstore-page">
          <div className="marketstore-body text-center py-5">
            <h3>{I18n.t(this.props.error || "try_later")}</h3>
          </div>
        </div>
      );
    }

    return (
        <div className="container-fluid marketstore-page">
          <div className="marketstore-body">
            <MarketStoreSlider />
            <div className="row">
              <div className="col-lg-3 d-none d-lg-block">
                <div className="store-left">
                  <StoreLeft />
                </div>
              </div>
              <div className="col-lg-9">
                <div className="store-center">
                  <StoreCenter />
                </div>
              </div>
            </div>
          </div>
        </div>
      );
  }
}

function mapStateToProps(reducers) {
  //console.log(reducers);
  return {
    user_id: reducers.session.auth.id,
    token: reducers.session.auth.access_token,
    auth: reducers.session.auth,

    error: reducers.marketstore.error,
    loading: reducers.marketstore.loading,
    marketstore: reducers.marketstore.item,
  };
}

const mapDispatchToProps = (dispatch) => ({
  LoadMarketStore: (token, params) =>
    dispatch(actions_store.loadItem({ token, params })),
  LoadMarketStoreOut: (params) =>
    dispatch(actions_store.loadItemOut({ params })),
  ClearMarketstore: () => dispatch(actions_store.clearMarketStore({})),
});

export default connect(mapStateToProps, mapDispatchToProps)(MarketStore);
